export default __webpack_public_path__ + "static/media/cards.a389a811.png";